/* src/config/constants/styles.js */

/* global window */

import { red, green, yellow } from '@material-ui/core/colors';

export const drawerWidth = 224;

export const statusColors = {
  approved: green[100],
  pending: yellow[100],
  declined: red[100],
};

export const colors = {
  green: green[100],
  yellow: yellow[100],
  red: red[100],
};

export const smallScreen = window.innerWidth < 500;



// WEBPACK FOOTER //
// ./src/config/constants/styles.js